export function artifactId() {
    return { 'X-Wix-Client-Artifact-Id': process.env.ARTIFACT_ID };
}
//# sourceMappingURL=artifact-id.js.map